import { gql } from "@apollo/client";

export const GET_ALL_USERS = gql`
  query GetAllUsers {
    getAllUsers {
      user_id
      username
      assigned_role
      is_active
    }
  }
`;

export const GET_ALL_ROLES = gql`
query GetAllRoles {
  getAllRoles {
    role_id
    role_name
    user_id
    features {
      feature_id
      feature_name
      create_access
      read_access
      update_access
      delete_access
    }
  }
}
`;

export const GET_ALL_FEATURES = gql`
  query GetAllFeatures {
    getAllFeatures {
      feature_id
      feature_name
    }
  }
`;

export const ADD_USER = gql`
  mutation CreateUser(
    $username: String!
    $password: String!
    $assignedRole: String!
  ) {
    createUser(
      username: $username
      password: $password
      assigned_role: $assignedRole
    ) {
      status
      message
    }
  }
`;

export const ADD_ROLE = gql`
mutation CreateRoleWithFeature($roleName: String!, $features: [FeatureInput!]!) {
  createRoleWithFeature(roleName: $roleName, features: $features) {
    status
    message
  }
}
`;

export const UPDATE_ROLE = gql`
mutation UpdateRole($roleId: String!, $roleName: String, $createdBy: String, $features: [FeatureInput]) {
  updateRole(role_id: $roleId, role_name: $roleName, created_by: $createdBy, features: $features) {
    role_id
    role_name
    user_id
    features {
      feature_id
      feature_name
      create_access
      read_access
      update_access
      delete_access
    }
  }
}
`;

export const UPDATE_USER = gql`
  mutation UpdateUserRole($userId: String!, $assignedRole: String!) {
    updateUserRole(user_id: $userId, assigned_role: $assignedRole) {
      user_id
      username
      assigned_role
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation DeleteRole($roleId: String!) {
    deleteRole(role_id: $roleId) {
      status
      message
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($userId: String!) {
    deleteUser(userId: $userId) {
      status
      message
    }
  }
`;
